import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../services/auth.service';
import { can } from '../config/permissions';

function ProtectedRoute({
  component: Component,
  children,
  requiredPermission = null,
  redirectTo = '/driver',
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!AuthService.isAuthenticated()) {
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
        }

        if (requiredPermission) {
          const currentUser = AuthService.getCurrentUser();
          const userRole = currentUser && currentUser.data && currentUser.data.role;
          if (!can(userRole, requiredPermission)) {
            return <Redirect to={redirectTo} />;
          }
        }

        return Component ? <Component {...props} /> : children;
      }}
    />
  );
}

export default ProtectedRoute;
